import { type TransformationContext } from "../common/translationUtils";
import {
  AL_AND_AR_ADD_DESCRIPTION,
  ALAR_NOT_RECOMMENDED_WARNING,
  ALAR_RECOMMENDED_LABEL,
  CONFIGURATOR_NAME_KEY,
  CONTACT_STC_ADD_DESCRIPTION,
  getStepNameKey,
  resolveExternalAdvancedTranslation,
  resolveInternalAdvancedTranslation,
  resolveRawAdvancedTranslation,
} from "../common/advancedTranslationUtils";
import { type LinearConfigurationDTO, type LinearConfigurationUpdateDTO } from "./dtos";
import { ConfiguratorType } from "../ConfiguratorType";
import type { TranslationModel } from "~/common/TranslationModel";

export const RESET_STANDARD_AND_LENGTH = "RESET_STANDARD_AND_LENGTH";

export const SYSTEM_ADVANCED_TRANSLATION_KEYS = [
  AL_AND_AR_ADD_DESCRIPTION,
  CONTACT_STC_ADD_DESCRIPTION,
  ALAR_NOT_RECOMMENDED_WARNING,
  ALAR_RECOMMENDED_LABEL,
];

export function buildAdvancedTranslationsForUnit(
  context: TransformationContext,
  dto: LinearConfigurationDTO | LinearConfigurationUpdateDTO,
) {
  const translations = {} as Dict<TranslationModel>;

  SYSTEM_ADVANCED_TRANSLATION_KEYS.forEach((key) =>
    resolveExternalAdvancedTranslation(
      translations,
      {
        ...context,
        configuratorType: ConfiguratorType.Rail, // Fake the type, so we properly resolve this
      },
      key,
    ),
  );

  resolveInternalAdvancedTranslation(translations, CONFIGURATOR_NAME_KEY, "page.registerForFree.banner.lc");

  dto.steps.forEach((step, index) => resolveRawAdvancedTranslation(translations, getStepNameKey(index + 1), step.name));

  return translations;
}
